import { Component, EventEmitter, input, InputSignal, Output, output } from '@angular/core';
import { ContractRateType } from "@modules/universal-billing/contract/contract.enums";
import { MoneyFormatPipe } from '@common/pipe/money-format.pipe';
import { NgForOf, NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import rentTypeGroups from '@common/rent-type-groups';
import { LocalizedDatePipe } from '@shared/pipes/localized-date.pipe';

@Component({
  selector: 'app-payments-of-contract-details',
  standalone: true,
  imports: [
    MoneyFormatPipe,
    NgForOf,
    NgIf,
    TranslatePipe,
    LocalizedDatePipe
  ],
  templateUrl: './payments-of-contract-details.component.html',
  styleUrl: './payments-of-contract-details.component.scss'
})
export class PaymentsOfContractDetailsComponent {
  data: InputSignal<any> = input();
  @Output() edit = new EventEmitter();

  protected readonly ContractRateType = ContractRateType;
  rateTypeList = rentTypeGroups;

  getRateTypeLabel(unitType: number): string {
    const type = this.rateTypeList.find(rt => rt.id === unitType);
    return type ? type.label : '';
  }

  getRateTypeFields(unitType: number): any[] {
    const type = this.rateTypeList.find(rt => rt.id === unitType);
    return type && type.fields ? type.fields : [];
  }
  onEdit(): void {
    this.edit.emit();
  }
}
